var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 24.4667L11.4 22.7333C9.15555 20.7111 7.3 18.9667 5.83333 17.5C4.36667 16.0333 3.2 14.7167 2.33333 13.55C1.46667 12.3833 0.861111 11.3111 0.516667 10.3333C0.172222 9.35556 0 8.35556 0 7.33333C0 5.24444 0.7 3.5 2.1 2.1C3.5 0.7 5.24444 0 7.33333 0C8.48889 0 9.58889 0.244444 10.6333 0.733333C11.6778 1.22222 12.5778 1.91111 13.3333 2.8C14.0889 1.91111 14.9889 1.22222 16.0333 0.733333C17.0778 0.244444 18.1778 0 19.3333 0C21.4222 0 23.1667 0.7 24.5667 2.1C25.9667 3.5 26.6667 5.24444 26.6667 7.33333C26.6667 8.35556 26.4944 9.35556 26.15 10.3333C25.8056 11.3111 25.2 12.3833 24.3333 13.55C23.4667 14.7167 22.3 16.0333 20.8333 17.5C19.3667 18.9667 17.5111 20.7111 15.2667 22.7333L13.3333 24.4667Z",
    fill: "#C80034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filledHeart.de68b30f2ea10147c69dd46bbf4364a0.svg";
export { ForwardRef as ReactComponent };